import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import Dropdown from '../../components/Dropdown';
import actions from '../../state/actions';
import { localize } from '../../i18n';

class RoomsTopBarFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'reset',
      filterKey: this.props.filterKey,
      sortKey: this.props.sortKey,
      request: 'close',
    };
  }

  render() {
    const filterOptions = [{
      filterKey: 'all',
      name: this.props.t('All'),
    }, {
      filterKey: 'housekeeping_status:unknown',
      name: this.props.t('Housekeeping Status: Unknown'),
    }, {
      filterKey: 'housekeeping_status:clean',
      name: this.props.t('Housekeeping Status: Clean'),
    }, {
      filterKey: 'housekeeping_status:dirty',
      name: this.props.t('Housekeeping Status: Dirty'),
    }, {
      filterKey: 'housekeeping_status:needs_inspection',
      name: this.props.t('Housekeeping Status: Inspection'),
    }, {
      filterKey: 'guest_service_status:not_specified',
      name: this.props.t('Guest Service Status: None'),
    }, {
      filterKey: 'guest_service_status:do_not_disturb',
      name: this.props.t('Guest Service Status: Do Not Disturb'),
    }, {
      filterKey: 'guest_service_status:make_up_room',
      name: this.props.t('Guest Service Status: Clean Requested'),
    }];

    const filterItems = filterOptions.map(item => (
      <li key={item.filterKey} className={`${(item.filterKey === this.state.filterKey) ? 'uk-active' : ''}`}>
        <span
          className="uk-list-item"
          onClick={(e) => {
            e.preventDefault();
            const sortKey = this.state.sortKey;
            this.setState({
              status: 'filtering',
              filterKey: item.filterKey,
              sortKey,
              request: 'close',
            });
            this.props.onFilter(item.filterKey, this.state.sortKey, this.state.direction);
          }}
        >
          {item.name}
        </span>
      </li>
    ));

    const currentFilter = _.find(filterOptions, { filterKey: this.state.filterKey }).name;

    return (
      <Dropdown
        href="#filter-dropdown"
        label={[
          <i className="material-icons" key="1">&#xE152;</i>,
          <span key="2" className="dropdown-label">{currentFilter}</span>,
          <i className="material-icons" key="3">&#xE313;</i>,
        ]}
        request={this.state.request}
        onChange={(changeRequest) => {
          this.setState({
            request: changeRequest === true ? 'open' : 'close',
          });
        }}
        size="large"
        wrapperClassName="uk-button-dropdown"
        className="md-btn md-btn-flat md-btn-small md-btn-wave waves-effect waves-button"
      >
        <ul className="uk-nav uk-nav-dropdown">
          {filterItems}
        </ul>
      </Dropdown>
    );
  }
}

RoomsTopBarFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
  filterKey: PropTypes.string,
  sortKey: PropTypes.string,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    filter: {
      locations: {
        filterKey,
        sortKey,
      },
    },
  } = state;
  return {
    filterKey,
    sortKey,
  };
};

const mapDispatchToProps = dispatch => ({
  onFilter(filterKey, sortKey) {
    dispatch(actions.filterLocations(filterKey, sortKey));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(RoomsTopBarFilter));



// WEBPACK FOOTER //
// ./src/views/rooms/RoomsTopBarFilter.js